var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePlay"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google_Play_symbol_2016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0292 18.0281C23.1769 16.8375 24.8172 15.928 24.9664 15.8451C25.4115 15.5984 25.8778 14.9687 24.9664 14.4653C24.6735 14.3032 23.0773 13.4216 21.0266 12.2885L18.2062 15.1672L21.0292 18.0281Z",
    fill: "#FFE300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.206 15.1672L9.18506 24.3743C9.38878 24.4004 9.6338 24.3458 9.91564 24.1895C10.4991 23.8661 16.7652 20.3919 21.0291 18.0279L18.206 15.1672V15.1672Z",
    fill: "#FF4E54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.206 15.1672L21.0265 12.2885C21.0265 12.2885 10.5432 6.49528 9.91563 6.14848C9.6744 6.01514 9.41139 5.9686 9.17859 6.02111L18.206 15.1672Z",
    fill: "#00F085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.206 15.1672L9.17845 6.02124C8.80558 6.10549 8.5 6.43237 8.5 7.0894C8.5 8.15671 8.5 22.3808 8.5 23.2769C8.5 23.8957 8.74039 24.3308 9.18492 24.3742L18.206 15.1672Z",
    fill: "#00E0FF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp4);
export default __webpack_public_path__ + "static/media/app4.67eadcdc1f98cc807e26fe0372e6dd2b.svg";
export { ForwardRef as ReactComponent };